import React from 'react';

import SynonymMeaning from '../SynonymMeaning';
import SynonymWord from '../SynonymWord';
import SynonymListInput from './SynonymListInput';

import { KEY_CODES } from '../../../constants/MogamboConstants';

export default class SynonymList extends React.Component {
  state = {
    newVariant: '',
    variants: [],
    enabled: false,
  };

  componentDidMount() {
    this.setState({
      variants: this.props.variants.sort(),
      enabled: this.props.enabled,
    });
  }

  render() {
    return (
      <div className="synonym-list">
        <div className="synonym-list-meanings">
          <SynonymMeaning
            text={this.props.title}
            selected
            enabled={this.state.enabled}
            onToggle={this._handleToggle}
          />
        </div>
        <div className="synonym-list-words">
          {/*
                        As we are moving towards a newer system of managing clusters/synonyms,
                        we want to temporarily disable editing of existing clusters so that the
                        migration can be completed smoothly.
                    */}
          {/* <SynonymListInput
                        value={this.state.newVariant}
                        onChange={e => this.setState({ newVariant: e.target.value })}
                        onKeyUp={this._handleKeyUp}
                    /> */}
          {this.state.variants.map((variant, i) => (
            <SynonymWord
              key={variant + i}
              text={variant}
              onDelete={e => this._handleDelete(variant)}
              readOnly
              addMode
            />
          ))}
        </div>
      </div>
    );
  }

  _handleKeyUp = e => {
    if (e.keyCode === KEY_CODES.ENTER_KEY) {
      const { newVariant } = this.state;
      if (this.state.variants.indexOf(newVariant) === -1) {
        const variants = [newVariant].concat(this.state.variants);
        this.setState({ newVariant: '', variants });
        this.props.onVariantAdd(newVariant);
      }
    }
  };

  _handleToggle = enabled => {
    this.setState({ enabled }, () => {
      this.props.onToggle(enabled)
    });
  };

  _handleDelete = variant => {
    const variants = this.state.variants.filter(v => v !== variant);
    this.setState({ variants });
    this.props.onVariantDelete(variant);
  };
}
